/*====================================================
	Steps Slider
====================================================*/
const selector_steps = 'js__slider-steps';

const elements_steps = document.querySelectorAll(
	`.${selector_steps}`
);

if (elements_steps !== null) {
	for (const element of elements_steps) {
		buildSwiperSteps(element);
	}
}

function buildSwiperSteps(swiperElement) {
	const sliderIdentifier = swiperElement.dataset.swiperId;
	return new Swiper(`#swiper-${sliderIdentifier}`, {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: false,
		breakpoints: {
			350: {
				slidesPerView: 1.1,
			},
			500: {
				slidesPerView: 1.5,
			},
			650: {
				slidesPerView: 2.3,
			},
			1024: {
				slidesPerView: 3.5,
			},
		},
	});
}